let icons = [
  'job-description-outline',
  'job-description',
  'conditional',
  'eye-closed',
  'field-group',
  'filter',
  'back',
  'door',
  'accessibility',
  'rich-text',
  'checkboxes',
  'checkbox',
  'link',
  'number',
  'paragraph',
  'text',
  'toggle',
  'section',
  'board',
  'popup',
  'sidebar',
  'table',
  'gallery',
  'application-o',
  'add-folder-o',
  'alarm-o',
  'alpha-o',
  'alpha-feedback-o',
  'beta-feedback-o',
  'beta-o',
  'calendar-o',
  'camera-o',
  'tick-circle-o',
  'circle-o',
  'dot-circle',
  'dot-circle-o',
  'close-circle-o',
  'add-circle-o',
  'warning-o',
  'info-o',
  'help-o',
  'clock-o',
  'cost-o',
  'clip-o',
  'cloud-o',
  'configure-o',
  'download-o',
  'employee-o',
  'envelope-o',
  'error-o',
  'eye-o',
  'feedback-o',
  'key',
  'home-o',
  'login-o',
  'logo-o',
  'logout-o',
  'offer-o',
  'checklist-o',
  'folder-open-o',
  'pencil-o',
  'star-o',
  'share-o',
  'shield-o',
  'swap-h-o',
  'swap-v-o',
  'tag-o',
  'trash-o',
  'trash-hard-o',
  'upload-o',
  'user-o',
  'refresh',
  'undo',
  'share',
  'ellipsis',
  'ellipsis-v',
  'drag',
  'sort',
  'add',
  'tick',
  'close',
  'left-end',
  'right-end',
  'angle-down',
  'angle-left',
  'angle-right',
  'angle-up',
  'search-user',
  'search',
  'logo',
  'menu',
  'live',
  'beta',
  'alpha-feedback',
  'alpha',
  'beta-feedback',
  'home',
  'error',
  'circle',
  'tick-circle',
  'clock',
  'info',
  'warning',
  'help',
  'cost',
  'alarm',
  'add-circle',
  'close-circle',
  'eye',
  'analytics',
  'arrow-left',
  'arrow-down',
  'arrow-up',
  'arrow-right',
  'knowledge-portal',
  'bullhorn',
  'calendar',
  'camera',
  'chat',
  'feedback',
  'sourcing',
  'assign',
  'paper',
  'doc',
  'doc-add',
  'app-close',
  'application',
  'offer',
  'onboarding',
  'notes',
  'copy',
  'cloud',
  'cloud-download',
  'cloud-upload',
  'extension',
  'succession',
  'integration',
  'settings',
  'third-party',
  'configure',
  'job',
  'database',
  'server',
  'download',
  'employee',
  'envelope',
  'eraser',
  'folder-add',
  'folder',
  'folder-open',
  'unarchive',
  'archive',
  'bucket-empty',
  'bucket-2',
  'bucket-3',
  'bucket-1',
  'history',
  'image',
  'iphone',
  'tablet',
  'laptop',
  'learning',
  'location',
  'login',
  'logout',
  'money',
  'palette',
  'pencil',
  'pin',
  'star',
  'print',
  'sort-down',
  'sort-up',
  'spade',
  'phone',
  'paw',
  'recycle',
  'support',
  'tag',
  'trash',
  'trash-hard',
  'tray',
  'unlock',
  'lock',
  'upload',
  'user',
  'user-add',
  'user-tick',
  'user-control',
  'team',
  'person',
  'trophy',
  'car',
  'bell',
  'coffee',
  'storage',
  'block',
  'reticle',
  'blade',
  'bookmark',
  'shield',
  'tape',
  'disc',
  'bomb',
  'box',
  'globe',
  'bulb',
  'flag',
  'chessboard',
  'twitter',
  'seek',
  'instagram',
  'linkedin',
  'skype',
  'google-plus',
  'facebook',
  'sketch',
  'github',
  'slack',
  'sad',
  'frown',
  'meh',
  'smile',
  'happy',
]
export default icons